export class WorkflowAutoRegisterResult {
  public success: boolean;
  public message: string;
  public reason: string;
}
